import type { client } from "@/utils/orpc.client";
import { QUERY_GC_TIMES } from "@/utils/query-policies";
import { readStoredQueryData } from "@/utils/query-storage";

type ListsItemsData = Awaited<ReturnType<typeof client.lists.getListsItems>>;

interface ListsItemsStorageSnapshot {
  data: ListsItemsData | undefined;
  updatedAt: number | undefined;
}

export function listsItemsStorageSnapshot(storageKey: string | null): ListsItemsStorageSnapshot {
  if (!storageKey) return { data: undefined, updatedAt: undefined };
  const stored = readStoredQueryData<ListsItemsData>(storageKey, QUERY_GC_TIMES.listMembership);
  return { data: stored?.data, updatedAt: stored?.cachedAt };
}
